import api from '../../api';
const invoices = '/student-management/young-apprentice/invoices';
// A batch retries only the row requested by the user, with the same durable key.
const options = { skipTransientRetry: true, skipGlobalErrorModal: true };
const InvoiceBatchService = {
  eligible: params => api.get(`${invoices}/eligible-apprentices`, { ...options, params }).then(response => response.data),
  preview: payload => api.post(`${invoices}/preview`, payload, options).then(response => response.data),
  generate: payload => api.post(invoices, payload, options).then(response => response.data),
  email: (id, payload) => api.post(`${invoices}/${id}/email`, payload, options).then(response => response.data),
  get: id => api.get(`${invoices}/${id}`, options).then(response => response.data),
};
export default InvoiceBatchService;
